import { render, staticRenderFns } from "./cliente.consultor.form.vue?vue&type=template&id=50236c5b&scoped=true&"
import script from "./cliente.consultor.form.vue?vue&type=script&lang=js&"
export * from "./cliente.consultor.form.vue?vue&type=script&lang=js&"
import style0 from "./cliente.consultor.form.vue?vue&type=style&index=0&id=50236c5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50236c5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
